import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
  CartesianGrid,
  Legend,
} from "recharts";

const COLORS = { High: "#DC2626", Medium: "#D97706", Low: "#16A34A" };

export function RiskBarChart({ counts }) {
  const data = [
    { name: "High", value: counts?.High || 0 },
    { name: "Medium", value: counts?.Medium || 0 },
    { name: "Low", value: counts?.Low || 0 },
  ];
  return (
    <div className="h-[200px] w-full" data-testid="risk-bar-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={150}>
        <BarChart data={data} margin={{ top: 8, right: 12, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="name" tick={{ fill: "#475569", fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fill: "#475569", fontSize: 12 }} />
          <Tooltip
            contentStyle={{
              fontSize: 12,
              borderRadius: 6,
              border: "1px solid #E2E8F0",
            }}
          />
          <Bar dataKey="value" radius={[6, 6, 0, 0]}>
            {data.map((d) => (
              <Cell key={`cell-${d.name}`} fill={COLORS[d.name]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function CycleTrendChart({ perCycle }) {
  const data = (perCycle || []).map((c) => ({
    name: c.cycle_name,
    inherent: c.inherent_risk_score,
    residual: c.residual_risk_score,
  }));
  return (
    <div className="h-[240px] w-full" data-testid="cycle-trend-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={180}>
        <BarChart data={data} margin={{ top: 8, right: 12, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
          <XAxis dataKey="name" tick={{ fill: "#475569", fontSize: 11 }} />
          <YAxis tick={{ fill: "#475569", fontSize: 12 }} />
          <Tooltip
            contentStyle={{ fontSize: 12, borderRadius: 6, border: "1px solid #E2E8F0" }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="inherent" fill="#94A3B8" name="Inherent" radius={[4, 4, 0, 0]} />
          <Bar dataKey="residual" fill="#2563EB" name="Residual (after resolutions)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
